export default "__VITE_ASSET__frKL8aEw__"